import { useTranslation } from 'react-i18next';

const Loading = () => {
	const { t } = useTranslation();
	return (
		<div className="flex h-40 flex-col items-center justify-center text-gray-700">
			<div className="mb-4 h-12 w-12 animate-spin rounded-full border-t-4 border-blue-500 border-opacity-50"></div>
			<p className="text-lg">{t('uploading')}...</p>
		</div>
	);
};

export default Loading;
